import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import "./NewsLetter.css";
import Signup from "./SignUp.js";

export default function NewsLetter() {
  // Structured data for SEO
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "OfferCatalog",
    "name": "Newsletter Discount Offer",
    "description": "Sign up for our newsletter and receive a 10% discount on next year's Christmas trees",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Christmas Tree Newsletter Subscription",
          "description": "Seasonal updates about Pumpkin Patch and Christmas tree offerings with exclusive discount"
        },
        "priceSpecification": {
          "@type": "PriceSpecification",
          "price": "0",
          "priceCurrency": "USD"
        },
        "eligibleCustomerType": "http://purl.org/goodrelations/v1#Enduser",
        "availability": "https://schema.org/InStock",
        "discount": "10% off next year's Christmas tree purchase"
      }
    ]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How often do you send newsletter emails?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We only send 4 to 5 emails throughout the year to inform you of seasonal offerings such as the Pumpkin Patch and Christmas tree season, including opening dates and address changes."
        }
      },
      {
        "@type": "Question",
        "name": "What discount do I get for signing up for the newsletter?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You receive a 10% discount on your next year's Christmas tree purchase when you sign up for our newsletter."
        }
      }
    ]
  };

  return (
    <>
      {/* Structured Data JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>

      <Box 
        component="section"
        className="newsletterBackground"
        aria-label="Newsletter Signup and Discount Offer"
        itemScope
        itemType="https://schema.org/OfferCatalog"
      >
        {/* Hidden H1 for SEO */}
        <h1 className="visually-hidden">
          Christmas Tree Newsletter - Get 10% Off Your Next Purchase
        </h1>

        {/* --- NEW WRAPPER ADDED FOR CENTERING --- */}
        {/* The parent (.newsletterBackground) centers this wrapper, and the wrapper contains all content. */}
        <Box className="centered-content-wrapper">
          
          {/*-------red box design below--------*/}
          <Box 
            component="article"
            className="newsletter-container"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/Offer"
          >
            <Typography 
              component="h2"
              className="newsletter-header"
              itemProp="name"
            >
              Sign up to receive a <strong>10% discount</strong> on your next year's Christmas trees!
            </Typography>
            <Typography 
              component="p"
              className="newsletter-body"
              itemProp="description"
            >
              Don't worry about being flooded with emails from us. We only send a
              handful of messages throughout the year, typically <strong>4 to 5 emails</strong>, to inform
              you of our seasonal offerings such as the <span itemProp="category">Pumpkin Patch</span> and <span itemProp="category">Christmas
              tree season</span>, including opening dates and any address changes.
            </Typography>
            <meta itemProp="price" content="0" />
            <meta itemProp="priceCurrency" content="USD" />
            <meta itemProp="availability" content="https://schema.org/InStock" />
          </Box>
          
          <Box component="div" role="form" aria-label="Newsletter subscription form">
            <Signup />
          </Box>
        </Box>
        {/* --- END OF WRAPPER --- */}
      </Box>
    </>
  );
}